import './assets/styles/main.css';
import '@vuepic/vue-datepicker/dist/main.css';
import 'floating-vue/dist/style.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import VueApexCharts from 'vue3-apexcharts';
import FloatingVue from 'floating-vue';

import App from './App.vue';
import router from './router';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(VueApexCharts);
app.use(FloatingVue);

router.isReady().then(() => {
    app.mount('#app');
});
